import React, { useEffect, useRef, useState } from 'react';
import { Box, Grid, Typography, Avatar, Button, AvatarGroup } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';
import { Female, Male } from "@mui/icons-material";
// import confetti from "canvas-confetti";
import { color } from 'constant/constant';
import { getUserAvatar } from 'helper/User';
import { loadImages } from 'helper/Image';

function LeaderBoard ({
  leaderBoard, allowShowConfetti = true, tournamentCard = false, isWrap = false
}){

  const canvasRef = useRef(null);
  const [ teams, setTeams ] = useState([])
  const [showAll, setShowAll] = useState(false);
  const VISIBLE_COUNT = 5;
  const showPartial = !showAll && teams.length > VISIBLE_COUNT;
  const visibleTeams = showAll ? teams : teams.length > 5 ? teams.slice(0, VISIBLE_COUNT + 1) : teams;

  const showConfetti = async () => {
    // confetti({
    //     particleCount: 200,
    //     startVelocity: 30,
    //     spread: 360,
    //     origin: {
    //         // x: Math.random(),
    //         x: 0,
    //         // since they fall down, start a bit higher than random
    //         y: Math.random() - 0.2
    //     }
    // });
    const timer = setTimeout(() => {
      // const myConfetti = confetti.create(canvasRef.current, {
      //   resize: true,
      //   useWorker: true,
      // });
      // myConfetti({
      //   spread: 200,
      //   particleCount: 300,
      //   origin: { y: -0.1 },
      //   startVelocity: 30
      //   // particleCount: 300,
      //   // startVelocity: 50,
      //   // spread: 360,
      //   // origin: { x: 0.5, y: 0.5 }
      // });
    }, 0)
    return () => clearTimeout(timer)
  }

  useEffect(() => {
    setTeams(leaderBoard)
    if (allowShowConfetti) showConfetti()
  }, [leaderBoard])

  return (
    <Box sx={{ minWidth: '100%', maxWidth: 400, mx: 'auto', mb: 1}}>
      {/* Header */}
      <Grid container sx={{ px: 2, pb: 0.3, pr: 0.6, fontWeight: 'bold', color: '#666' }}>
        <Grid item xs={tournamentCard ? 5.5 : 6}></Grid>
        <Grid item xs={1.2} textAlign={"center"}><TCLabel subtitle bold>W-L-T</TCLabel></Grid>
        <Grid item xs={1.6} textAlign={"center"}><TCLabel subtitle bold>% Win</TCLabel></Grid>
        <Grid item xs={1} textAlign={"center"}><TCLabel subtitle bold>Diff</TCLabel></Grid>
        <Grid item xs={1.1} textAlign={"center"}><TCLabel subtitle bold>P</TCLabel></Grid>
        <Grid item xs={tournamentCard ? 1.5 : 1.1} textAlign={"center"}><TCLabel subtitle bold>Avg P</TCLabel></Grid>
      </Grid>

      {/* Rows */}
      {visibleTeams.map((team, idx) => {
        const isPartial = showPartial && idx === VISIBLE_COUNT;

        return (
          <Box
            key={team.name}
            sx={{
              backgroundColor: team.isWinner ? '#fad142' : team.isSecond ? '#e0e0e0' : (!team.isWinner && idx == 0 && isWrap) ? '#fad142' : (!team.isWinner && idx == 1 && isWrap) ? '#e0e0e0' :'#f5f5f5',
              borderRadius: 2,
              px: 2,
              py: 1.5,
              pr: 0.6,
              mb: 0.6,
              display: 'flex',
              alignItems: isPartial ? 'auto' : 'center',
              boxShadow: team.isWinner ? 1 : (!team.isWinner && idx == 0 && isWrap) ? 1 : 0,
              opacity: isPartial ? 0.3 : 1,
              overflow: isPartial ? 'hidden' : 'visible',
              height: isPartial ? 30 : 'auto',
              pointerEvents: isPartial ? 'none' : 'auto',
            }}
          >
            <Grid container alignItems="center">
              <Grid item xs={tournamentCard ? 5.5 : 6} sx={{ display: 'flex', alignItems: 'center'}}>
                {team.isWinner && <EmojiEventsIcon sx={{ width: '1em', height: '1em', marginLeft: -1, marginRight: 0.4, color: 'white' }} />}
                {(!team.isWinner && idx == 0 && isWrap) && <EmojiEventsIcon sx={{ width: '1em', height: '1em', marginLeft: -1, marginRight: 0.4, color: 'white' }} />}
                <TCLabel variant="body1" sx={{ fontWeight: 'medium' }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    {/* {
                      team.isWinner &&
                      <canvas
                        ref={canvasRef}
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          zIndex: 2,
                          pointerEvents: "none",
                        }}
                      />
                    } */}
                    {
                      (!team.isWinner && idx != 0 && isWrap) &&
                      <div style={{
                        marginRight: 8
                      }}><TCLabel>{!team.isWinner ? (!team.isWinner && idx == 0 && isWrap) ? '' : idx + 1 : ''}</TCLabel></div>
                    }
                    {
                      (!team.isWinner && !isWrap) &&
                      <div style={{
                        marginRight: 8
                      }}><TCLabel>{!team.isWinner ? (!team.isWinner && idx == 0 && isWrap) ? '' : idx + 1 : ''}</TCLabel></div>
                    }
                    <div style={{
                      marginRight: 8
                    }}>
                      {
                        team.userIds && 
                        <AvatarGroup spacing={8} max={4} sx={{ justifyContent: 'flex-end', 
                            '& .MuiAvatar-root': { width: 30, height: 30, fontSize: 15 }
                        }}>
                            {
                                team.userIds.map(v => {
                                    return (
                                        <Avatar sx={{ width: 40, height: 40, zIndex: 0 }} 
                                          src={loadImages(v.verifyId?.idPhoto, true, 250)}
                                          imgProps={{ loading: 'lazy' }}
                                        />
                                    )
                                })
                            }
                        </AvatarGroup>
                      }
                      {
                        !team.userIds &&
                        <Avatar 
                            sx={{
                              width: 40, height: 40
                            }}
                            src={getUserAvatar(team.matchGroupPlayerId)}
                        />
                      }
                    </div>
                    <div>
                      {
                        team.userIds && team.userIds.map( v => {
                          return (
                            <div style={{ display: 'flex'}}>
                              <TCLabel overflowLine={1}>{v.verifyId?.idName}</TCLabel>
                              <TCLabel bold>{v.gender == "male" ? <Male fontSize='xs' style={{color: color.blue}}/> : v.gender == "female" ? <Female fontSize='xs' style={{color: 'pink'}}/> : ''}</TCLabel>
                            </div>
                          )
                        })
                      }
                      {
                        !team.userIds &&
                        <div style={{ display: 'flex'}}>
                          <TCLabel overflowLine={1}>{team.matchGroupPlayerId.name}</TCLabel>
                          <TCLabel bold>{team.matchGroupPlayerId.gender == "male" ? <Male fontSize='xs' style={{color: color.blue}}/> : team.matchGroupPlayerId.gender == "female" ? <Female fontSize='xs' style={{color: 'pink'}}/> : ''}</TCLabel>
                        </div>
                      }
                      {/* Club */}
                      {
                        team.matchGroupPlayerId?.club &&
                        <>
                            <div style={{
                                display: 'flex',
                                marginLeft: 0
                            }}>
                                {/* <Avatar sx={{width: 20, height: 20, marginRight: 0.5}} src={team.matchGroupPlayerId.club ? team.matchGroupPlayerId.club.logo : clubPlaceholder} /> */}
                                <TCLabel subtitle overflowLine={1}>{team.matchGroupPlayerId.club ? team.matchGroupPlayerId.club.name : "No Club"}</TCLabel>
                            </div>
                        </>
                    }
                    </div>
                  </div>
                </TCLabel>
              </Grid>
              <Grid item xs={1.2} textAlign={"center"}><TCLabel subtitle>{team.wlt}</TCLabel></Grid>
              <Grid item xs={1.6} textAlign={"center"}><TCLabel subtitle>{team.wr.toFixed(0)}%</TCLabel></Grid>
              <Grid item xs={1} textAlign={"center"}><TCLabel subtitle>{team.difference > 0 ? `+${team.difference}` : team.difference}</TCLabel></Grid>
              <Grid item xs={1.1} textAlign={"center"}>
                <TCLabel subtitle sx={{ fontWeight: 'bold' }}>{team.score}</TCLabel>
              </Grid>
              <Grid item xs={tournamentCard ? 1.5 : 1.1} textAlign={"center"}><TCLabel bold>{team.avgPoint}</TCLabel></Grid>
            </Grid>
          </Box>
        )
      })}
      {teams.length > 5 && (
        <Box textAlign="center" mt={1}>
          <div onClick={() => setShowAll(!showAll)}>
            <TCLabel style={{fontSize: 10, fontWeight: 'bold'}}>{
                !showAll ? 'Show more' : 'Show Less'
            }</TCLabel>
          </div>
        </Box>
      )}
      {/* Footer Explanation */}
      {/* <Box sx={{ px: 2, pl:0, mt: 1, fontSize: '0.8rem', color: '#666' }}>
        <TCLabel subtitle>W-L-T = Wins - Losses - Ties</TCLabel>
        <TCLabel subtitle>Winrate = Win Rate %</TCLabel>
        <TCLabel subtitle>Diff = Points difference</TCLabel>
        <TCLabel subtitle>P = Points</TCLabel>
        <TCLabel subtitle>AVG P = Average Points</TCLabel>
      </Box> */}
    </Box>
  );
};

export default LeaderBoard;